/* global Config */

// Vendor Libs
import React from 'react';
import {Provider} from 'react-redux';
import {hot} from 'react-hot-loader/root';
import {BrowserRouter, Route} from 'react-router-dom';

// Components
import store from './components/redux/store';
import Main from './components/layout/main';

const App = () => (
  <Provider store={store}>
    <BrowserRouter>
      <Route path="/" component={Main} />
    </BrowserRouter>
  </Provider>
);

export default Config.base.env === 'development' ? hot(App) : App;